import React, { useState, useEffect } from "react";
import apiCall from "./../../API/API";
import "./Upi.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BankDetails = () => {
  const [bankName, setBankName] = useState("");
  const [ifsc, setIfscCode] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [holder, setAccountHolderName] = useState("");
  const [ac_type, setAccountType] = useState("");
  const [branch, setBankBranch] = useState("");
  const [loading, setLoading] = useState(false);
  const [bankData, setBankData] = useState([]);
  const [originalAccountNumber, setOriginalAccountNumber] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);

  const fetchBankData = async () => {
    const { data, error } = await apiCall("GET", "/get-payment-method");
    if (error) {
      toast.error(error.message || "An error occurred");
    } else {
      const bankList = data?.activeOptions?.manual?.bank || [];
      const firstBank = bankList?.[0];

      setBankData(firstBank ? [firstBank] : []);

      if (firstBank) {
        setBankName(firstBank.bankName || "");
        setIfscCode(firstBank.ifsc || "");
        setAccountNumber(firstBank.accountNumber || "");
        setAccountHolderName(firstBank.holder || "");
        setAccountType(firstBank.ac_type || "");
        setBankBranch(firstBank.branch || "");
        setOriginalAccountNumber(firstBank.accountNumber || "");
        setIsEditMode(false);
      } else {
        setBankName("");
        setIfscCode("");
        setAccountNumber("");
        setAccountHolderName("");
        setAccountType("");
        setBankBranch("");
        setOriginalAccountNumber("");
        setIsEditMode(true);
      }
    }
  };

  useEffect(() => {
    fetchBankData();
  }, []);

  const handleEditClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsEditMode(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (hasBankDetail && !isEditMode) {
      return;
    }

    setLoading(true);

    const payload = {
      bankName,
      ifsc,
      accountNumber,
      holder,
      ac_type,
      branch,
    };

    const endpoint = bankData.length
      ? "/edit-bank-details"
      : "/add-bank-details";
    const requestData = bankData.length
      ? { currentAccountNumber: originalAccountNumber, ...payload }
      : payload;

    const { data, error } = await apiCall("POST", endpoint, requestData);
    if (error) {
      toast.error(error.message || "An error occurred");
    } else {
      toast.success(
        data.message ||
          (bankData.length
            ? "Bank details updated successfully"
            : "Bank details submitted successfully")
      );
      setIsEditMode(false);
      fetchBankData();
    }

    setLoading(false);
  };

  const hasBankDetail = bankData.length > 0;

  return (
    <React.Fragment>
      <Container className="mt-4">
        <section id="bankForm">
          <div className="d-flex justify-content-center">
            <h2>Bank Details Form</h2>
          </div>
          <section id="formContent">
            <div className="form">
              <Row>
                <Col lg={6} style={{ margin: "auto" }}>
                  <form onSubmit={handleSubmit} className="registerForm">
                    <div id="formFields">
                      <div className="mb-3">
                        <label htmlFor="bankName">Bank Name</label>
                        <input
                          type="text"
                          id="bankName"
                          className="form-control"
                          value={bankName}
                          placeholder="Enter your Bank name"
                          onChange={(e) => setBankName(e.target.value)}
                          disabled={hasBankDetail && !isEditMode}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="ifscCode">IFSC Code</label>
                        <input
                          type="text"
                          id="ifscCode"
                          className="form-control"
                          value={ifsc}
                          placeholder="Enter your IFSC Code"
                          onChange={(e) => setIfscCode(e.target.value)}
                          disabled={hasBankDetail && !isEditMode}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="accountNumber">Account Number</label>
                        <input
                          type="text"
                          id="accountNumber"
                          className="form-control"
                          value={accountNumber}
                          placeholder="Enter Account Number"
                          onChange={(e) => setAccountNumber(e.target.value)}
                          disabled={hasBankDetail && !isEditMode}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="accountHolderName">
                          Account Holder Name
                        </label>
                        <input
                          type="text"
                          id="accountHolderName"
                          className="form-control"
                          value={holder}
                          placeholder="Enter Account Holder Name"
                          onChange={(e) => setAccountHolderName(e.target.value)}
                          disabled={hasBankDetail && !isEditMode}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="accountType">Account Type</label>
                        <select
                          id="accountType"
                          className="form-control"
                          value={ac_type}
                          style= {{color: "white"}}
                          onChange={(e) => setAccountType(e.target.value)}
                          disabled={hasBankDetail && !isEditMode}
                          required
                        >
                          <option value="">Select Account Type</option>
                          <option value="Savings">Savings</option>
                          <option value="Current">Current</option>
                        </select>
                      </div>
                      <div className="mb-3">
                        <label htmlFor="bankBranch">Bank Branch</label>
                        <input
                          type="text"
                          id="bankBranch"
                          className="form-control"
                          value={branch}
                          placeholder="Enter Bank Branch"
                          onChange={(e) => setBankBranch(e.target.value)}
                          disabled={hasBankDetail && !isEditMode}
                          required
                        />
                      </div>
                      {hasBankDetail && !isEditMode ? (
                        <Button
                          type="button"
                          variant="primary"
                          onClick={handleEditClick}
                        >
                          Edit
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          variant="primary"
                          disabled={loading}
                        >
                          {loading
                            ? hasBankDetail
                              ? "Updating..."
                              : "Submitting..."
                            : hasBankDetail
                            ? "Update"
                            : "Submit"}
                        </Button>
                      )}
                      {(isEditMode || !hasBankDetail) && (
                        <Button
                          type="button"
                          variant="secondary"
                          className="ms-2"
                          onClick={() => {
                            if (hasBankDetail) {
                              fetchBankData();
                            } else {
                              setBankName("");
                              setIfscCode("");
                              setAccountNumber("");
                              setAccountHolderName("");
                              setAccountType("");
                              setBankBranch("");
                            }
                          }}
                        >
                          {hasBankDetail && isEditMode ? "Cancel Edit" : "Cancel"}
                        </Button>
                      )}
                    </div>
                  </form>
                </Col>
              </Row>
            </div>
          </section>
        </section>
        {/* {success === 'true' ? (
          <AlertMessage
            msg="Bank information submitted successfully"
            icon={<BsCheckCircle />}
          />
        ) : success === 'false' ? (
          <AlertMessage
            msg={error || 'Submission failed'}
            icon={<BiErrorCircle />}
          />
        ) : ''} */}

        {/* <div id="directIncomeDiv">
          <Row id="directTableRow" className="text-center">
            <Col md="12" className="p-0">
              <div style={{ width: "100%" }}>
                <table>
                  <tr>
                    <th>S No.</th>
                    <th>Bank Name</th>
                    <th>IFSC Code</th>
                    <th>Account Number</th>
                    <th>Account Holder Name</th>
                    <th>Account Type</th>
                    <th>Bank Branch</th>
                    <th>Delete Bank</th>
                    <th>Set Default</th>
                  </tr>
                  {Array.isArray(bankData) &&
                    bankData?.slice(0, 1).map((x, i) => (
                      <tr key={i}>
                        <td className="text-center">{i + 1}</td>
                        <td className="text-center">{x?.bankName}</td>
                        <td className="text-center">{x?.ifsc}</td>
                        <td className="text-center">{x?.accountNumber}</td>
                        <td className="text-center">{x?.holder}</td>
                        <td className="text-center">{x?.ac_type}</td>
                        <td className="text-center">{x?.branch}</td>
                        <td className="text-center">
                          <button
                            className="block-btn"
                            onClick={() => handleDelete(x?.accountNumber)}
                          >
                            Delete Bank
                          </button>
                        </td>
                        <td className="text-center">
                          <button
                            className={`block-btn ${
                              defaultAccountNumber === x?.accountNumber
                                ? "default-btn"
                                : ""
                            }`}
                            onClick={() => handleDefault(x?.accountNumber)}
                            disabled={defaultAccountNumber === x?.accountNumber}
                          >
                            {defaultAccountNumber === x?.accountNumber
                              ? "Default"
                              : "Set Default"}
                          </button>
                        </td>
                      </tr>
                    ))}
                </table>
              </div>
            </Col>
          </Row>
        </div> */}
        {/* <ToastContainer className="toast-container" /> */}
      </Container>
    </React.Fragment>
  );
};

export default BankDetails;
